var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"1"}},[_c(_setup.BackButton,{on:{"click":function($event){return _vm.$emit('goBackClicked')}}},[_vm._v(" Back To Buildings ")])],1),_c('v-col',{attrs:{"cols":"12","md":"10"}},[_c('div',{staticClass:"text-h6 text-center font-weight-bold primary--text"},[_vm._v(" Building Details ")])]),_c('v-spacer')],1),_c('div',{staticClass:"d-flex justify-end mb-4"},[_c('v-btn',{staticClass:"text-none",attrs:{"color":"success","depressed":""},on:{"click":_setup.printApplicationDetails}},[_c('span',[_vm._v("Print Application Details")]),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-printer")])],1),_c('v-btn',{staticClass:"ml-2 text-none",attrs:{"color":"warning","depressed":""},on:{"click":_setup.downloadApplicationDetail}},[_c('span',[_vm._v("Download Application Doc")]),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-printer")])],1)],1),_c('v-row',{attrs:{"justify-md":"center"}},[(_vm.$mobileBreakpoint)?_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":_setup.smallScreenHouseDetails.tableHeaders,"items":_setup.smallScreenHouseDetails.houseDetailsEnclosedInArray}})],1):_vm._l((_setup.buildingDetails),function(houseDetailSection,sectionName,index){return _c('v-col',{key:sectionName,attrs:{"cols":"12","md":"6"}},[(index == 0)?_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Building Plan Details")])],1)],1):_vm._e(),_c('v-simple-table',{staticClass:"building_application-details-table",attrs:{"dense":""}},[_c('tbody',_vm._l((houseDetailSection),function(houseAttribute,attributeTitle){return _c('tr',{key:attributeTitle},[_c('td',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(attributeTitle)+" ")]),_c('td',[(attributeTitle !== 'Occupied')?[_vm._v(" "+_vm._s(houseAttribute))]:[(houseAttribute === true)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("mdi-check-circle")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v("mdi-close")])]],2)])}),0)])],1)})],2),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Architect Details")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
        {
          text: 'Architect Name',
          value: 'architect_name',
          fn: (building_architect) => building_architect.architects ? building_architect.architects.first_name + ' ' + building_architect.architects.last_name : ''

        },
        {
          text: 'ID No.',
          value: 'id_number',
          fn: (building_architect) => building_architect.architects ? building_architect.architects.id_number : ''

        },
        {
          text: 'Phone No.',
          value: 'phone_number',
          fn: (building_architect) => building_architect.architects ? building_architect.architects.phone_number : ''

        },
        {
          text: 'Email',
          value: 'email',
          fn: (building_architect) => building_architect.architects ? building_architect.architects.email_address : ''

        },
        {
          text: 'License Expiry Date',
          value: 'license_expiry',
          fn: (building_architect) => building_architect.architects ? building_architect.architects.license_expiry_date : ''

        },

      ],"dense":"","items":_setup.building_architect,"bodyClasses":"text-caption"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Client Details")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
        {
          text: 'Customer Name',
          value: 'customer_name',
          fn: (building_owner) => building_owner.clients ? building_owner.clients.customer_name : ''

        },
        {
          text: 'Designation',
          value: 'designation',
          fn: (building_owner) => building_owner.clients ? building_owner.clients.designation : ''

        },
        {
          text: 'Phone No.',
          value: 'phone_number',
          fn: (building_owner) => building_owner.clients ? building_owner.clients.phone_number1 : ''

        },
        {
          text: 'ID No.',
          value: 'id_no',
          fn: (building_owner) => building_owner.clients ? building_owner.clients.id_number : ''

        },
        {
          text: 'Client Type',
          value: 'client_type',
          fn: (building_owner) => building_owner.clients ? building_owner.clients.client_type : ''

        },

      ],"dense":"","items":_setup.building_owner,"bodyClasses":"text-caption"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Linked Property Details")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
        {
          text: 'PRN No.',
          value: 'prn_no',
          fn: (building_linked_properties) => building_linked_properties.properties ? building_linked_properties.properties.prn : ''

        },
        {
          text: 'Owner/Customer',
          value: 'owner',
          fn: (building_linked_properties) => {

            let all_names = '';


            if (building_linked_properties.properties.active_property_owners.length > 0) {

              building_linked_properties.properties.active_property_owners.forEach((item, index) => {
                if (index == 0) {
                  all_names = all_names + item.owner.customer_name

                } else {
                  all_names = all_names + ' & ' + item.owner.customer_name

                }

              })

            }

            return all_names

          }

        },
        {
          text: 'Sub County',
          value: 'sub_county',
          fn: (building_linked_properties) => building_linked_properties.properties.sub_county ? building_linked_properties.properties.sub_county.sub_county_name : ''

        },
        {
          text: 'Property Type.',
          value: 'property_type',
          fn: (building_linked_properties) => ''

        },
        {
          text: 'LR Number',
          value: 'lr_number',
          fn: (building_linked_properties) => building_linked_properties.properties ? building_linked_properties.properties.lr_no : ''

        },

        {
          text: 'Block/Plot Number',
          value: 'block_plot_number',
          fn: (building_linked_properties) => building_linked_properties.properties ? building_linked_properties.properties.block_no : ''

        },

        {
          text: 'Status',
          value: 'status',
          fn: (building_linked_properties) => building_linked_properties.properties ? building_linked_properties.properties.status?.status_name : ''

        },

      ],"dense":"","items":_setup.building_linked_properties,"bodyClasses":"text-caption"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Attached Documents")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
        {
          text: 'No.',
          value: 'id',
          fn: (building_attached_documents) => _setup.props.building_application.documents.findIndex(x => x.id == building_attached_documents.id) + 1

        },
        {
          text: 'Document Name',
          value: 'document_name',
          fn: (building_attached_documents) => building_attached_documents ? building_attached_documents.document_name : ''

        },
        {
          text: 'Document Type',
          value: 'phone_number',
          fn: (building_attached_documents) => building_attached_documents ? building_attached_documents.document_type : ''

        },
        {
          text: 'Actions',
          value: 'download',
          action: true,
          //fn: (building_application) => building_application.workflow_status.status_name
        },


      ],"dense":"","items":_setup.building_attached_documents,"bodyClasses":"text-caption"},scopedSlots:_vm._u([{key:"item.download",fn:function({ item: document_item }){return [_c(_setup.ActionButton,{attrs:{"action":_setup.actions.downloadReceipt,"text":"Download Document","inTable":""},on:{"click":function($event){return _setup.onDownloadAttachedDocument(document_item)}}})]}},{key:"item.view",fn:function({ item }){return [_c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"button mr-1 primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('viewBuilding', item)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-eye ")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t("viewMsg")))])])],1)]}}])})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Bills and Receipts")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
        {
          text: 'No.',
          value: 'id',

        },
        {
          text: 'Type',
          value: 'type',

        },
        {
          text: 'Number',
          value: 'number',
          fn: (bills_and_receipts_array) => {
            if (bills_and_receipts_array.type == 'Bill') {
              return _setup.bills_and_receipts_object?.bill_number

            } else if (bills_and_receipts_array.type == 'Receipt') {
              return _setup.bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.receipt_number

            }

            return ''

          }

        },
        {
          text: 'date',
          value: 'Date',
          fn: (bills_and_receipts_array) => {
            if (bills_and_receipts_array.type == 'Bill') {
              return _setup.getFormattedBillDate(_setup.bills_and_receipts_object?.created_at)

            } else if (bills_and_receipts_array.type == 'Receipt') {
              if (_setup.bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.payment_date) {
                return _setup.getFormattedBillDate(_setup.bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.payment_date)
              }

            }

            return ''

          }

        },
        {
          text: 'amount',
          value: 'Amount',
          fn: (bills_and_receipts_array) => {
            if (bills_and_receipts_array.type == 'Bill') {
              return _setup.bills_and_receipts_object?.amount

            } else if (bills_and_receipts_array.type == 'Receipt') {
              return _setup.bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.amount

            }

            return ''

          }

        },
        {
          text: 'status',
          action: true,
          value: 'status',
          // fn: (bills_and_receipts_array) =>{
          //   if(bills_and_receipts_array.type == 'Bill'){
          //     return bills_and_receipts_object?.bill_workflow?.status_name

          //   }else if(bills_and_receipts_array.type == 'Receipt'){

          //     if(bills_and_receipts_object?.bills_invoices?.[0].invoice_receipt?.receipt?.amount){
          //       return 'Paid'

          //     }

          //     return 'Unpaid'


          //   }

          //   return ''

          // }

        },

        {
          text: 'Download',
          value: 'download',
          action: true

        },


      ],"dense":"","items":_setup.bills_and_receipts_array,"bodyClasses":"text-caption"},scopedSlots:_vm._u([{key:"item.status",fn:function({ item: bills_and_receipts_array_item }){return [_c('span',{class:{
            'font-weight-bold': true,
            'green--text': _setup.checkIfBillReceiptPaid(bills_and_receipts_array_item.type),
            'red--text': !_setup.checkIfBillReceiptPaid(bills_and_receipts_array_item.type),
          }},[_vm._v(_vm._s(_setup.returnBillReceiptString(bills_and_receipts_array_item.type)))])]}},{key:"item.download",fn:function({ item: bills_and_receipts_array_item }){return [(bills_and_receipts_array_item.type == 'Bill')?_c(_setup.ActionButton,{attrs:{"action":_setup.actions.downloadBill,"inTable":""},on:{"click":function($event){return _setup.onDownloadBillClicked(bills_and_receipts_array_item)}}}):_c(_setup.ActionButton,{attrs:{"action":_setup.actions.downloadReceipt,"inTable":""},on:{"click":function($event){return _setup.onDownloadReceiptClicked(bills_and_receipts_array_item)}}})]}}])})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Plupa and Circulation Certificate Documents")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
        {
          text: 'No.',
          value: 'id',


        },
        {
          text: 'Document Name',
          value: 'doc_name',

        },
        {
          text: 'Actions',
          value: 'view',
          action: true,
          //fn: (building_application) => building_application.workflow_status.status_name
        },

      ],"dense":"","items":_setup.plupa_and_circulation_docs,"bodyClasses":"text-caption"},scopedSlots:_vm._u([{key:"item.view",fn:function({ item }){return [_c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"button mr-1 primary--text",attrs:{"icon":""},on:{"click":function($event){return _setup.showSelectedDialog(item)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-eye ")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t("viewMsg")))])])],1)]}}])})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Workflow")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
        {
          text: 'User',
          value: 'user',
        },
        {
          text: 'Role',
          value: 'role',
        },
        {
          text: 'Action',
          value: 'action',
        },
        {
          text: 'Comment',
          value: 'comment',
        },
        {
          text: 'Approval Date',
          value: 'actioned',
        },

      ],"dense":"","items":_setup.workflow_approvers_array,"bodyClasses":"text-caption"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"auto"}},[_c(_setup.ViewItemSectionTitle,[_vm._v("Owner(s)")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
        {
          text: 'Customer Name',
          value: 'customer_name',
          fn: (property_owners) => property_owners.owner ? property_owners.owner.customer_name : ''

        },
        {
          text: 'ID Number',
          value: 'designation',
          fn: (property_owners) => property_owners.owner ? property_owners.owner.id_number : ''

        },
        {
          text: 'Phone No.',
          value: 'phone_number',
          fn: (property_owners) => property_owners.owner ? property_owners.owner.phone_number1 : ''

        },
        {
          text: 'Customer No.',
          value: 'id_no',
          fn: (property_owners) => property_owners.owner ? property_owners.owner.customer_number : ''

        },
        {
          text: 'Email',
          value: 'email',
          fn: (property_owners) => property_owners.owner ? property_owners.owner.email_address : ''

        },

      ],"dense":"","items":_setup.property_owners,"bodyClasses":"text-caption"}})],1)],1),(_setup.printApplicationDetailsPdfDialogOpen)?_c(_setup.ViewPdf,{attrs:{"pdfUrl":_setup.returnPrintDetailsUrl(),"dialogOpen":_setup.printApplicationDetailsPdfDialogOpen,"title":"Building Application Details","printBtnText":"Print Application Details"},on:{"update:dialogOpen":function($event){_setup.printApplicationDetailsPdfDialogOpen=$event},"update:dialog-open":function($event){_setup.printApplicationDetailsPdfDialogOpen=$event},"closeViewPdfDialog":_setup.closeViewPdfDialog}}):_vm._e(),(_setup.viewCirculationCertDialogOpen)?_c(_setup.ViewPdf,{attrs:{"pdfUrl":_setup.returnCirclCertUrl(),"dialogOpen":_setup.viewCirculationCertDialogOpen,"title":"Circulation Certificate","printBtnText":"Print Circulation Certificate"},on:{"update:dialogOpen":function($event){_setup.viewCirculationCertDialogOpen=$event},"update:dialog-open":function($event){_setup.viewCirculationCertDialogOpen=$event},"closeViewPdfDialog":_setup.closeViewPdfDialog}}):_vm._e(),(_setup.viewPlupaPdfDialogOpen)?_c(_setup.ViewPdf,{attrs:{"pdfUrl":_setup.returnPlupaUrl(),"dialogOpen":_setup.viewPlupaPdfDialogOpen,"title":"PLUPA DC8 Document","printBtnText":"Print PLUPA DC8"},on:{"update:dialogOpen":function($event){_setup.viewPlupaPdfDialogOpen=$event},"update:dialog-open":function($event){_setup.viewPlupaPdfDialogOpen=$event},"closeViewPdfDialog":_setup.closeViewPdfDialog}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }